export const findIndexReverse = (arrayInput, callbackFinder) => {
  const index = arrayInput.findIndex(callbackFinder);
  return index === -1 ? null : index - arrayInput.length;
};
